import styled from 'styled-components';
import { GENERAL_COLORS } from '../../../constants/colors';

const InputContainer = styled.label`
  width: 80px;
  height: 20px;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 5px;
  cursor: ${(p) => (p.disabled ? 'default' : 'text')};
  &,
  * {
    box-sizing: border-box;
  }

  &:not(:focus-within):after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 5px;
    border: 1px solid
      ${(p) =>
        p.theme.color[p.error ? 'red' : !p.disabled ? 'background' : 'pale']};
  }

  &:hover:not(:focus-within):after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 5px;
    border: 1px solid
      ${(p) =>
        p.theme.color[p.error ? 'red' : p.disabled ? 'background' : 'pale']};
  }

  > div {
    display: flex;
    position: absolute;
  }
`;

const InputStyle = styled.input`
  z-index: ${p => p.isBackground ? 2 : 0 };
  box-sizing: border-box;
  font-size: 12px;
  width: 100%;
  height: 100%;
  color: ${(p) => (p.error ? GENERAL_COLORS.red : p.theme.color.mainFont)};
  background-color: ${(p) => p.theme.color.background};
  border-radius: 5px;
  padding-left: 5px;
  text-overflow: ellipsis;
  outline: none;
  border: none;
  position: relative;
  display: flex;

  &:focus {
    background-color: ${(p) => p.theme.color.backgroundRush};
    border: 1px solid ${(p) => p.theme.color.background};
  }
`;

const OutSideContainer = styled.div`
  z-index: 1;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
`;

export const Styled = {
  InputContainer,
  InputStyle,
  OutSideContainer,
};
